import React from 'react';
import PropTypes from 'prop-types';

import { trackAllAnalytics } from '@bnnvara/analytics/src/track';
import useAnalyticProperties from '@/hooks/useAnalyticProperties';

import * as S from './styled';

export const ClickWrapper = ({ children, url, type, title }) => {
  const analyticsProperties = useAnalyticProperties();

  const sendHeroTypeAnalytics = () => {
    trackAllAnalytics(`Klik_header_op_een_${type}`, {
      ...analyticsProperties,
      category: 'Header',
    });
  };

  if (url) {
    return (
      <S.HeroPresentation
        onClick={sendHeroTypeAnalytics}
        href={url}
        key={title}
        role="presentation"
        tabIndex="0"
        title={title}
      >
        {children}
      </S.HeroPresentation>
    );
  }
  return (
    <S.HeroPresentationWithoutUrl key={title} role="presentation">
      {children}
    </S.HeroPresentationWithoutUrl>
  );
};

ClickWrapper.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};
